exports = module.exports = require("../../../../apps/experimentation-ui/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ms-PeoplePicker-suggestion .ms-Suggestions-title {\n  color: #383838;\n  font-weight: 600;\n}", ""]);

